import {
    defaultBaseQuery,
    transformErrorResponse,
    transformRequest,
    transformSuccessResponse
} from '@/services';
import { createApi } from '@reduxjs/toolkit/query/react';

const leaveRequestsAPI = createApi({
    baseQuery: defaultBaseQuery,
    reducerPath: 'leaveRequestsAPI',
    endpoints: (builder) => ({

        getListLeaveRequest: builder.query({
            query: (requestData) => {
                const params = {
                    isMonth: false,
                    ...(requestData?.fromDate && { fromDate: requestData.fromDate }),
                    ...(requestData?.departmentId && { departmentId: requestData.departmentId }),
                    ...(requestData?.designationId && { designationId: requestData.designationId }),
                    ...(requestData?.searchText && { searchText: requestData.searchText }),
                    ...(requestData?.sortDir && { sortDir: requestData.sortDir }),
                    page: requestData?.page ?? 0,
                    size: requestData?.size ?? 10,
                };
                return {
                    url: `/leave/history`,
                    method: 'GET',
                    params,
                };
            },
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getLeaveRequestsLams: builder.query({
            query: (requestData) => {
                const params = {
                    ...(requestData?.fromDate && { fromDate: requestData.fromDate }),
                    ...(requestData?.toDate && { toDate: requestData.toDate }),
                    ...(requestData?.encryptedDepartmentId && { encryptedDepartmentId: requestData.encryptedDepartmentId }),
                    ...(requestData?.searchText && { searchText: requestData.searchText }),
                    ...(requestData?.sortDir && { sortDir: requestData.sortDir }),
                    page: requestData?.page ?? 0,
                    size: requestData?.size ?? 10,
                };
                return {
                    url: `/leave`,
                    method: 'GET',
                    params,
                };
            },
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getLeaveRequestById: builder.query({
            query: (leaveRequestId) => ({
                url: `/leave/${leaveRequestId}`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        leaveAction: builder.mutation({
            query: (data) => ({
                url: `/leave/action`,
                method: 'PUT',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

    })
});

export const {
    useLazyGetListLeaveRequestQuery, useLazyGetLeaveRequestByIdQuery,
    useLeaveActionMutation, useLazyGetLeaveRequestsLamsQuery
} = leaveRequestsAPI;

export default leaveRequestsAPI;
